export default __webpack_public_path__ + "static/media/plik.9a167f54.svg";